import { render } from "./OtherWorkListTour.vue?vue&type=template&id=208059a2"
import script from "./OtherWorkListTour.vue?vue&type=script&lang=js"
export * from "./OtherWorkListTour.vue?vue&type=script&lang=js"

import "./OtherWorkListTour.vue?vue&type=style&index=0&id=208059a2&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__